import { useState } from 'react';
import { updateItems } from '@/mocks/home';
import { useDemoToast } from '@/components/feature/DemoToast';
import SectionHeading from './SectionHeading';

const typeTone: Record<string, string> = {
  视频: 'bg-primary-100 text-primary-700',
  证据: 'bg-secondary-100 text-secondary-900',
  图集: 'bg-accent-100 text-accent-900',
  资源: 'bg-background-200 text-foreground-700',
};

export default function UpdatesSection() {
  const [email, setEmail] = useState('');
  const { show } = useDemoToast();

  const handleSubscribe = () => {
    const trimmed = email.trim();
    show(trimmed ? '订阅成功，更新合集将第一时间提醒你（演示）' : '请先填写邮箱（演示）');
    if (trimmed) {
      setEmail('');
    }
  };

  return (
    <section id="updates" className="hll-scroll-anchor w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="UPDATE LOG"
          title="更新动态 · 素材一直在补"
          desc="新增、补档与修订都会留下记录，按时间倒序列出，方便回头确认某一组黑料吃瓜网视频或图片是哪天补进来的。"
        />

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <ol className="relative border-l border-background-300 pl-6">
              {updateItems.map((item, index) => (
                <li key={item.id} className={index === updateItems.length - 1 ? '' : 'pb-8'}>
                  <span className="absolute -left-[7px] mt-1.5 flex h-3.5 w-3.5 items-center justify-center rounded-full border-2 border-background-100 bg-primary-500"></span>
                  <div className="rounded-lg border border-background-300/60 bg-background-50 p-4 md:p-5">
                    <div className="flex flex-wrap items-center gap-3">
                      <span className={`rounded-full px-2.5 py-0.5 text-[11px] ${typeTone[item.type] ?? 'bg-background-200 text-foreground-700'}`}>
                        {item.type}
                      </span>
                      <span className="text-xs text-foreground-500">{item.time}</span>
                    </div>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-800 md:text-base">{item.title}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <div className="lg:col-span-5">
            <div className="flex h-full flex-col justify-between rounded-lg border border-primary-200 bg-primary-50 p-6">
              <div>
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-notification-3-line text-xl"></i>
                </span>
                <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950">订阅更新提醒</h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                  留下邮箱，新上架的黑料吃瓜网视频、图片与实锤合集整理好后会提醒你，省得反复刷新。
                </p>
              </div>
              <div className="mt-6">
                <div className="flex flex-col gap-2 sm:flex-row">
                  <input
                    type="text"
                    inputMode="email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    placeholder="your@email.com"
                    className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 focus:border-primary-400"
                  />
                  <button
                    type="button"
                    onClick={handleSubscribe}
                    className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600"
                  >
                    订阅
                  </button>
                </div>
                <p className="mt-3 text-[11px] leading-relaxed text-foreground-500">
                  订阅为展示效果，不会真实发送或保存邮箱。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}